<template>
    <v-flex xs12 pb-3>
        <v-toolbar height="56" color="primary">
            <v-toolbar-title class="subheading white--text">
                Declaração de Seguro e Outros Arquivos
            </v-toolbar-title>
        </v-toolbar>
        <v-card>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12>
                        <span v-if="dadosCarregados.arquivoQuestionarioList.length == 0">Nenhum arquivo para ser exibido</span>
                        <v-list two-line class="pa-0" id="listaDeArquivos">
                            <template v-for="(arquivo, index) in dadosCarregados.arquivoQuestionarioList">
                              <div :key="arquivo.id">
                                <v-layout row wrap align-center justify-space-between> 
                                  <v-flex xs12 sm12 md3 pr-2 text-xs-left >
                                    <v-card  style="border: 1px solid #BABABA; border-radius: 5px;" flat>
                                      <v-card-text style="padding: 5px 10px; margin: 0;">
                                        <b>{{ arquivo.descricao }} {{ arquivo.tipoProposta ? ' - ' + arquivo.tipoProposta.descricao : ' - ' + arquivo.tipoArquivo.descricao }}</b>
                                        <br />
                                        <v-layout align-center >
                                          <v-flex xs7 style="padding-top: -5px; margin-top: -5px;">{{ toLocaleDateTimeString(arquivo.dataCriacao) }}</v-flex>
                                          <v-flex text-xs-right xs5 style="padding-top: -15px; margin-top: -5px; padding: 0px; margin: 0px;">
                                            <v-tooltip bottom color="blue darken-1"> 
                                              <v-btn 
                                                :id="'downloadBtnArquivo_' + arquivo.id"
                                                style="padding: -20px 0px 0px 0px; margin: -10px 0px 0px 0px;" 
                                                slot="activator" 
                                                icon 
                                                :class="`btnDownloadArquivo-${arquivo}`" 
                                                color="transparent" 
                                                @click.native="downloadArquivo(arquivo)">
                                                <v-icon text-xs-right color="blue darken-1">get_app</v-icon>
                                              </v-btn>
                                              <div style="text-align: center;">Download</div>
                                            </v-tooltip>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                    </v-card>
                                  </v-flex>
                                  <!--<v-flex grow style="padding-left: -10px; margin-left: -10px;" v-if="arquivo.tipoArquivo.id != arquivoHelperComputed.PROPOSTA_ASSINADA" text-xs-left>
                                    <v-tooltip bottom color="primary"> 
                                      <v-btn slot="activator" icon color="transparent" @click.native="abrirModalParecer(conjunto)">
                                        <v-icon text-xs-left medium color="primary">chat</v-icon>
                                      </v-btn>
                                      <div style="text-align: center;">Visualizar parecer do analista</div>
                                    </v-tooltip>
                                  </v-flex>-->
                                  <v-spacer></v-spacer>
                                  <v-flex shrink xs6 md1 text-xs-right order-xs4 order-md5>
                                    <v-tooltip bottom color="red">  
                                      <v-btn slot="activator" v-if="permissaoAnalisaSolicitacao && arquivo.tipoArquivo.id == arquivoHelperComputed.DECLARACAO_SEGURO"
                                        @click="abrirModalAvisoDeletarDeclaracaoSeguro(getConjuntoDeclaracaoSeguroDoArquivo(arquivo.id))" flat icon
                                        :id="'excluirArquivo_' + arquivo.id">
                                        <v-icon medium color="error">delete</v-icon>
                                      </v-btn>
                                      <v-btn slot="activator" v-else-if="arquivo.tipoArquivo.id == arquivoHelperComputed.OUTROS && arquivo.idUsuario == usuarioHelperComputed.USUARIO_LOGADO().idUsuario"
                                        @click="excluirArquivo(arquivo)" flat icon
                                        :id="'excluirArquivo_' + arquivo.id">
                                        <v-icon medium color="error">delete</v-icon>
                                      </v-btn>
                                      <div style="text-align: center;">Excluir</div>
                                    </v-tooltip>
                                  </v-flex>
                                </v-layout>
                                <v-flex v-if="index+1 != dadosCarregados.arquivoQuestionarioList.length">
                                  <v-divider></v-divider>
                                </v-flex>
                              </div>
                            </template>
                        </v-list>
                    </v-flex>
                    <v-flex xs12>
                        <v-btn
                        :block="$vuetify.breakpoint.xsOnly"
                        :disabled="model.status.id == eStatusComputed.statusEnum.RESERVA_NAO_ACEITA
                          || model.status.id == eStatusComputed.statusEnum.DIRECIONAMENTO_COMERCIAL 
                          || model.status.id == eStatusComputed.statusEnum.SEGURO_REJEITADO 
                          || model.status.id == eStatusComputed.statusEnum.ENCERRADO
                          || model.status.id == eStatusComputed.statusEnum.PROPOSTA_EXPIRADA"
                        class="white--text right"
                        @click.native="modalUpload = true"
                        id="btnEnviarArquivo"
                        color="primary">
                            Enviar
                            <v-icon right class="hidden-sm-and-down">backup</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
        <v-dialog v-model="modalUpload" max-width="500px" persistent>
          <v-card>
            <template>
              <v-card class="mx-auto" max-width="500">
                <v-card-title class="title  justify-space-between primary--text">
                  <span>&nbsp; Upload de documentos</span>
                </v-card-title>

                <v-window>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <br>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Selecione o tipo de arquivo:</span>
                      </v-flex>
                    </v-layout>
                    <v-container grid-list-lg>
                      <v-form ref="formEnvioArquivo" v-model="formEnvioArquivoValid" 
                      @submit.prevent="formEnvioArquivoValid" 
                      enctype="multipart/form-data">
                        <v-layout row wrap>
                          <v-flex xs12 text-xs-center style="border: 2px solid #D6D6D6; border-radius: 3px; border-style: dotted;">
                            
                            <v-flex xs12 text-xs-center v-if="permissaoAnalisaSolicitacao">
                              <v-layout row wrap align-center justify-center v-if="!arquivoDeclaracaoSeguro">
                                <v-flex xs12 lg8 >
                                  <v-btn :disabled="!anexoPermitidoDeclaracaoSeguro"
                                    block color="secondary"
                                    @click="pickFile('inputArquivoDeclaracaoSeguro')">DECLARAÇÃO DE SEGURO
                                    <input id="inputArquivoDeclaracaoSeguro" ref="inputArquivoDeclaracaoSeguro" style="display: none"
                                      type="file"
                                      v-on:change="addArquivoDeclaracaoSeguro()"/>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                              <v-flex v-else>
                                <v-layout row wrap align-center align-content-center
                                  style="border: 2px solid #E5E5E5; border-radius: 3px; background-color: #E5E5E5; max-height: 45px;">
                                  <v-flex xs9 lg10 text-xs-left >
                                    <i>{{ arquivoDeclaracaoSeguro.nomeArquivo }}</i>
                                  </v-flex>
                                  <v-flex xs2 text-xs-right>
                                    <v-btn id="descartarArquivoDeclaracaoSeguro" flat icon @click="removeArquivo('arquivoDeclaracaoSeguro')">
                                      <v-icon color="red">delete</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-flex>

                            <br v-if="arquivoDeclaracaoSeguro && arquivoOutros">

                            <v-flex xs12 text-xs-center>
                              <v-layout align-center justify-center v-if="!arquivoOutros">
                                <v-flex xs12 lg8 >
                                  <v-btn
                                    :disabled="model.status.id == eStatusComputed.statusEnum.RESERVA_NAO_ACEITA
                                    || model.status.id == eStatusComputed.statusEnum.DIRECIONAMENTO_COMERCIAL 
                                    || model.status.id == eStatusComputed.statusEnum.SEGURO_REJEITADO 
                                    || model.status.id == eStatusComputed.statusEnum.ENCERRADO
                                    || model.status.id == eStatusComputed.statusEnum.PROPOSTA_EXPIRADA
                                    || arquivoDeclaracaoSeguro != null"
                                    block color="secondary"
                                    @click="pickFile('inputArquivoOutros')">OUTROS
                                    <input id="inputArquivoOutros" ref="inputArquivoOutros" style="display: none"
                                      type="file"
                                      v-on:change="addArquivoOutros()"/>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                              <v-flex v-else>
                                <v-layout row wrap align-center align-content-center
                                  style="border: 2px solid #E5E5E5; border-radius: 3px; background-color: #E5E5E5; max-height: 45px;">
                                  <v-flex xs9 lg10 text-xs-left >
                                    <i>{{ arquivoOutros.nomeArquivo }}</i>
                                  </v-flex>
                                  <v-flex xs2 text-xs-right>
                                    <v-btn id="descartarArquivoOutros" flat icon @click="removeArquivo('arquivoOutros')">
                                      <v-icon color="red">delete</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-flex>

                          </v-flex>

                          <v-flex xs12 sm6 v-if="arquivoDeclaracaoSeguro != null && permissaoAnalisaSolicitacao">
                            <br>
                            <v-menu
                              id="datePickerDeclaracaoSeguroMenu"
                              ref="datePickerDeclaracaoSeguroMenu"
                              lazy
                              :close-on-content-click="false"
                              v-model="datePicker.opened"
                              transition="scale-transition"
                              offset-y
                              full-width
                              :nudge-left="40"
                              max-width="290px"
                            >
                              <v-text-field
                                id="datePickerDeclaracaoSeguroTextField"
                                ref="datePickerDeclaracaoSeguroTextField"
                                slot="activator"
                                label="Inicio de Vigência*"
                                v-model="datePicker.dataVigenciaFormatted"
                                prepend-icon="event"
                                :rules="formRulesComputed.arquivo.propostaAssinada.dataVigenciaDesejada(datePicker.dataVigencia)"
                                required
                                validate-on-blur
                              ></v-text-field>
                              <v-date-picker
                                id="datePickerDeclaracaoSeguroComponent"
                                ref="datePickerDeclaracaoSeguroComponent"
                                @input="$refs.datePickerDeclaracaoSeguroMenu.save(datePicker.dataVigencia)"
                                locale="pt-br"
                                v-model="datePicker.dataVigencia"
                                :min="dataVigenciaDesejadaPropostaAssinada"
                                no-title
                                scrollable
                                actions>
                              </v-date-picker>
                            </v-menu>
                          </v-flex>
                          
                          <v-flex xs12 text-xs-center>
                            <v-text-field label="Descrição"
                              id="txtDescricaoArquivo"
                              v-model="descricaoEnvio"
                              :rules="formRulesComputed.arquivo.proposta.descricao(descricaoEnvio)">
                            </v-text-field>
                          </v-flex>
                                
                        </v-layout>
                      </v-form>                        
                    </v-container>
                  </v-card-text>
                </v-window>

                <v-card-actions>
                  <template>
                    <v-btn flat id="btnFecharModalUploadDeclaracaoOutros" @click.native="fecharModalArquivos()" color="primary">
                      Fechar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn id="btnEnviarArquivoDeclaracaoOutros"
                        @click.native="enviaArquivos()"
                        :loading="enviandoArquivo"
                        :disabled="!formEnvioArquivoValid || enviandoArquivo
                          || model.status.id == eStatusComputed.statusEnum.PROPOSTA_EXPIRADA
                          || !validadeArquivosAdicionados"
                        color="primary">
                            Enviar
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </template>
          </v-card>
        </v-dialog>
        
        <v-dialog v-model="modalAviso.opened" max-width="550px" persistent>
          <v-card>
            <v-toolbar height="56" color="primary">
                <v-icon dark large>warning</v-icon>
            </v-toolbar>
            <v-card-text>
                <br>
                <h3 class="primary--text">{{modalAviso.message}}</h3>
            </v-card-text>
            <br>
            <v-card-actions>
              <v-btn flat 
                @click.native="fechaModalAviso" 
                color="primary"
                id="btnFecharModalAviso">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="modalAvisoDeletarDeclaracaoSeguro.opened" max-width="550px" persistent>
          <v-card>
            <v-card-title class="title  justify-space-between primary--text">
              <span> &nbsp; Excluir proposta</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <div> <big>{{modalAvisoDeletarDeclaracaoSeguro.message}}</big></div>
              </v-container>
            </v-card-text>
            <br>
            <v-card-actions>
              <v-btn flat 
                @click.native="fecharModalAvisoDeletarDeclaracaoSeguro()" 
                color="primary"
                :loading="modalAvisoDeletarDeclaracaoSeguro.processando"
                :disabled="modalAvisoDeletarDeclaracaoSeguro.processando"
                id="btnFecharModalAvisoDeletarDeclaracaoSeguro">Fechar
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn id="btnConfirmaExclusaoDeclaracaoSeguro"
                color="primary"
                :loading="modalAvisoDeletarDeclaracaoSeguro.processando"
                :disabled="modalAvisoDeletarDeclaracaoSeguro.processando"
                @click="excluirArquivo(modalAvisoDeletarDeclaracaoSeguro.declaracaoSeguroEmExclusao.arquivoQuestionarioUm)">Confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-snackbar
            id="snackMensagemEnvio"
            :timeout="6000"
            :color="snackbar.sucesso ? 'success' : 'error'"
            multi-line
            v-model="snackbar.visivel">
            {{ snackbar.mensagem }}
            <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
        </v-snackbar>
    </v-flex>
</template>

<script>
import axios from 'axios'
import arquivoFunctions from '@/components/pages/solicitacao-consulta/ArquivoFunctions'
import CustomFormat from '@/helpers/custom-format'
import arquivoHelper from '@/helpers/arquivo-helper'
import formRules from '@/helpers/form-rules';
import permissoes from '@/helpers/permissoes'
import estatus from '@/helpers/estatus'
import usuarioHelper from '@/helpers/usuario-logado';

export default {
  name: 'arquivosoutros',
  props: ["model"],
  data: () => {
    return {
      snackbar: {
        sucesso: false,
        mensagem: '',
        visivel: false
      },
      modalUpload: false,
      modalAviso: {
        opened: false,
        message: '',
      },
      dadosCarregados: {
        conjuntoDeclaracaoSeguroList: [],
        arquivoQuestionarioList: []
      },
      formEnvioArquivoValid: false,
      descricaoEnvio: '',
      arquivoDeclaracaoSeguro: null,
      arquivoOutros: null,
      arquivoModel: {
        descricao: '',
        nomeArquivo: null,
        tipoArquivo: {}, 
        idQuestionario: null,
        tokenUsuario: null,
        mimeType: null,
        downloadLink: null,
        visualizacaoAnalista: false,
        visualizacaoCliente: false,
        tipoProposta: {},
        arquivo: null
      },
      datePicker: {
        opened: false,
        dataVigencia: null,
        dataVigenciaFormatted: null
      },
      modalAvisoDeletarDeclaracaoSeguro: {
        opened: false,
        message: '',
        declaracaoSeguroEmExclusao: null,
        processando: false
      },
      enviandoArquivo: false,
      urlDeclaracaoSeguro: `${process.env.URL_QUESTIONARIOMS}/v1/arquivos/declaracoes-seguro`,
      urlOutros: `${process.env.URL_QUESTIONARIOMS}/v1/arquivos/outros`
    }
  },
  computed: {
    permissaoAnalisaSolicitacao: function() {
      return permissoes.verificaPermissao(permissoes.SolicitacaoConsulta.ANALISA_SOLICITACAO)
    },
    arquivoHelperComputed: function() {
      return arquivoHelper;
    },
    usuarioHelperComputed: function () {
      return usuarioHelper;
    },
    eStatusComputed: function () {
      return estatus;
    },
    formRulesComputed: function() {
      return formRules;
    },
    anexoPermitidoDeclaracaoSeguro: function() {
      const self = this;
      return  (self.arquivoOutros == null && self.model.status.id == estatus.statusEnum.EFETIVANDO_PROPOSTA) ||
              (self.arquivoOutros == null && self.model.status.id == estatus.statusEnum.APOLICE_EM_EMISSAO && !self.declaracaoSeguroAnexada);
    },
    declaracaoSeguroAnexada: function() {
      const self = this;
      if (self.dadosCarregados.conjuntoDeclaracaoSeguroList) {
        return self.dadosCarregados.conjuntoDeclaracaoSeguroList.length > 0;
      }
      return false;
    },
    dataVigenciaDesejadaPropostaAssinada: function() {
      const self = this;
      var data = null;
      self.$parent.$children.forEach(component => {
        if (component.$options._componentTag == "arquivospropostas") {
          component._data.conjuntoArquivoList.forEach(conjuntoArquivo => {
            if (conjuntoArquivo.conjuntoPropostaAssinada){
              data = conjuntoArquivo.conjuntoPropostaAssinada.dataVigenciaDesejada ? conjuntoArquivo.conjuntoPropostaAssinada.dataVigenciaDesejada : null;
            }
          })
        }
      });
      return data;
    },
    validadeArquivosAdicionados: function() {
      const self = this;
      if  (   (self.arquivoDeclaracaoSeguro != null && self.arquivoOutros == null && self.datePicker.dataVigenciaFormatted != '' && self.model.status.id == estatus.statusEnum.EFETIVANDO_PROPOSTA && self.descricaoEnvio != '')
          ||  (self.arquivoDeclaracaoSeguro != null && self.arquivoOutros == null && self.datePicker.dataVigenciaFormatted != '' && (self.model.status.id == estatus.statusEnum.APOLICE_EM_EMISSAO && !self.declaracaoSeguroAnexada) && self.descricaoEnvio != '')
          ||  (self.arquivoDeclaracaoSeguro == null && self.arquivoOutros != null && self.descricaoEnvio != '')) {
        return true;
      }
      return false;
    },
  },
  watch: {
    'datePicker.dataVigencia': function(value) {
      const self = this;
      if (self.datePicker.dataVigencia) {
        self.datePicker.dataVigenciaFormatted = CustomFormat.parseDateToFormatedString(value);
      }
    }
  },
  mounted: function () {
    this.carregaArquivos();
  },
  methods: {
    pickFile: function(ref) {
      eval('this.$refs.' + ref + '.click()');
    },
    getConjuntoDeclaracaoSeguroDoArquivo: function(idArquivo) {
      const self = this;
      if (self.dadosCarregados.arquivoQuestionarioList && self.dadosCarregados.conjuntoDeclaracaoSeguroList) {
        return self.dadosCarregados.conjuntoDeclaracaoSeguroList.find((declaracaoSeguro) => {
          return declaracaoSeguro.arquivoQuestionarioUm.id == idArquivo;
        });
      }
      return null;
    },
    carregaArquivos: async function () {
      const self = this;
      await axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/arquivos/declaracoes-seguro?idQuestionario=${self.model.id}`,
        { headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }})
      .then((response) => {
        const declaracaoSeguroList = response.data;
        if (declaracaoSeguroList.length > 0) {
          self.dadosCarregados.arquivoQuestionarioList.push(declaracaoSeguroList[0].arquivoQuestionarioUm);
          self.dadosCarregados.conjuntoDeclaracaoSeguroList = declaracaoSeguroList;
        }
      })
      .catch((error) => {
        self.snackbar.visivel = true;
        self.snackbar.sucesso = false;
        self.snackbar.mensagem = error.response.data.message;
      });
      await axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/buscaArquivos?idQuestionario=${self.model.id}`,
        { headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }})
      .then((response) => {
        self.dadosCarregados.arquivoQuestionarioList = response.data
          .filter(arquivo => arquivo.tipoArquivo.id == arquivoHelper.OUTROS || arquivo.tipoArquivo.id == arquivoHelper.DECLARACAO_SEGURO)
          .sort((a, b) => { return Date.parse(b.dataCriacao) - Date.parse(a.dataCriacao); });
      })
      .catch((error) => {
        self.snackbar.visivel = true;
        self.snackbar.sucesso = false;
        self.snackbar.mensagem = error.response.data.message;
      });
    },
    downloadArquivo: function (arquivo) {
        const self = this;
        axios.get(
            `${process.env.URL_QUESTIONARIOMS}/v1/no-auth/downloadArquivo?id=${arquivo.id}&transportadoraNome=${self.$parent.transportadoraModel.nome}`,
            {
              responseType: "blob",
              headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` },
            })
          .then((response) => {
            if (self.permissaoAnalisaSolicitacao) {
                self.$parent.$refs.parecerRef.atualizaStatusList();
                self.$parent.carregaQuestionario();
            }
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf"}));
            link.download = response.headers.nomearquivo;
            document.body.appendChild(link)
            link.click();
          })
          .catch((error) => {
            self.snackbar.visivel = true;
            self.snackbar.sucesso = false;
            self.snackbar.mensagem = error.response.data.message;
          })
    },
    fechaModalAviso: function () {
        const self = this;
        self.modalAviso.message1 = '';
        self.modalAviso.message2 = '';
        self.modalAviso.opened = false;
    },
    addArquivoDeclaracaoSeguro: function() {
      const self = this;
      
      if(!self.arquivoDeclaracaoSeguro && self.permissaoAnalisaSolicitacao) {
        const fileInput = self.$refs.inputArquivoDeclaracaoSeguro.files[0];
      
        self.arquivoModel.nomeArquivo = fileInput.name;
        self.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.DECLARACAO_SEGURO;
        self.arquivoModel.idQuestionario = self.model.id;
        self.arquivoModel.tokenUsuario = usuarioHelper.USUARIO_LOGADO().token;
        self.arquivoModel.mimeType = fileInput.type;

        self.arquivoDeclaracaoSeguro = JSON.parse(JSON.stringify(self.arquivoModel));
        arquivoFunctions.arquivoParaByteArray(fileInput).then((response) => {
          if (response) {
            self.arquivoDeclaracaoSeguro.arquivo = response;
          } else {
            self.arquivoDeclaracaoSeguro = null;
          }
        });

        self.datePicker.dataVigencia = self.dataVigenciaDesejadaPropostaAssinada;
        self.resetArquivoModel();
      }
    },
    addArquivoOutros: function() {
      const self = this;
      
      if(!self.arquivoOutros) {
        const fileInput = self.$refs.inputArquivoOutros.files[0];
      
        self.arquivoModel.nomeArquivo = fileInput.name;
        self.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.DECLARACAO_SEGURO;
        self.arquivoModel.idQuestionario = self.model.id;
        self.arquivoModel.tokenUsuario = usuarioHelper.USUARIO_LOGADO().token;
        self.arquivoModel.mimeType = fileInput.type;

        self.arquivoOutros = JSON.parse(JSON.stringify(self.arquivoModel));
        arquivoFunctions.arquivoParaByteArray(fileInput).then((response) => {
          if (response) {
            self.arquivoOutros.arquivo = response;
          } else {
            self.arquivoOutros = null;
          }
        });

        self.resetArquivoModel();
      }
    },
    enviaArquivos: function(propostaAssinada) {
      const self = this;
      self.enviandoArquivo = true;
      self.$store.commit('startLoading');

      var arquivoList = [];
      var formData = new FormData();
      var url = null;

      if (self.arquivoDeclaracaoSeguro) {
        self.arquivoDeclaracaoSeguro.descricao = self.descricaoEnvio || 'Sem descrição';
        arquivoList.push(self.arquivoDeclaracaoSeguro);
        formData.append('conjuntoDeclaracaoSeguroModel', JSON.stringify(self.montarConjuntoDeclaracaoSeguroModel()));
        url = self.urlDeclaracaoSeguro;
      }
      if (self.arquivoOutros) {
        self.arquivoOutros.descricao = self.descricaoEnvio || 'Sem descrição';
        arquivoList.push(self.arquivoOutros);
        url = self.urlOutros;
      }

      formData.append('arquivoList', JSON.stringify(arquivoList));
      formData.append('idQuestionario', self.model.id);
      formData.append('transportadoraNome', self.$parent.transportadoraModel.nome);
      formData.append('usuarioPerfil', usuarioHelper.USUARIO_LOGADO().perfil.id);
      formData.append('usuarioNome', usuarioHelper.USUARIO_LOGADO().nome);
   
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.setRequestHeader('Authorization', `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`);

      xhr.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          self.carregaArquivos();
          self.$parent.carregaQuestionario();

          self.snackbar.visivel = true;
          self.snackbar.sucesso = true;
          self.snackbar.mensagem = 'Arquivo enviado com sucesso.';

          self.fecharModalArquivos();
        } else {
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = JSON.parse(this.response).message;
          self.snackbar.visivel = true;
        }
        self.$store.commit('endLoading');
        self.enviandoArquivo = false;
      };

      xhr.send(formData);
    },
    excluirArquivo: function (arquivo) {
        const self = this;
        const arquivoEmDelecao = arquivo;
        
        if (arquivoEmDelecao.tipoArquivo == arquivoHelper.DECLARACAO_SEGURO) {
          self.modalAvisoDeletarDeclaracaoSeguro.processando = true;
        }

        axios.delete(`${process.env.URL_QUESTIONARIOMS}/v1/excluiArquivo?id=${arquivoEmDelecao.id}&transportadoraNome=${self.$parent.transportadoraModel.nome}&usuarioPerfil=${usuarioHelper.USUARIO_LOGADO().perfil.id}`, 
            {
            headers: {
                'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
        })
        .then((response) => {
            if (response.data == true) {
              self.carregaArquivos();
            }
            if (arquivoEmDelecao.tipoArquivo.id == arquivoHelper.DECLARACAO_SEGURO) {
              self.dadosCarregados.conjuntoDeclaracaoSeguroList = self.dadosCarregados.conjuntoDeclaracaoSeguroList.filter((declaracaoSeguro) => {
                declaracaoSeguro.arquivoQuestionarioUm.id != arquivoEmDelecao.id;
              });
              self.fecharModalAvisoDeletarDeclaracaoSeguro();
            }
            self.snackbar.visivel = true;
            self.snackbar.sucesso = response.data;
            self.snackbar.mensagem = response.data ? 'Arquivo excluído com sucesso.' : 'Exclusão negada: você não enviou este arquivo.';
        }).catch((error) => {
            self.snackbar.visivel = true;
            self.snackbar.sucesso = false;
            self.snackbar.mensagem = error.response.data.message;
        })
    },
    abrirModalAvisoDeletarDeclaracaoSeguro: function(declaracaoSeguro) {
      const self = this;
      self.modalAvisoDeletarDeclaracaoSeguro.message = 'Deseja excluir a declaração de seguro "' + declaracaoSeguro.arquivoQuestionarioUm.descricao + '"?';
      self.modalAvisoDeletarDeclaracaoSeguro.declaracaoSeguroEmExclusao = declaracaoSeguro;
      self.modalAvisoDeletarDeclaracaoSeguro.opened = true;
    },
    fecharModalAvisoDeletarDeclaracaoSeguro: function() {
        const self = this;
        self.modalAvisoDeletarDeclaracaoSeguro.message = '';
        self.modalAvisoDeletarDeclaracaoSeguro.opened = false;
        self.modalAvisoDeletarDeclaracaoSeguro.declaracaoSeguroEmExclusao = null;
        self.modalAvisoDeletarDeclaracaoSeguro.processando = false;
    },
    toLocaleDateTimeString: function (val) {
        return CustomFormat.toLocaleDateTimeString(val);
    },
    montarConjuntoDeclaracaoSeguroModel: function() {
      const self = this;
      const dataVigenciaParsed = new Date(self.datePicker.dataVigencia);
      return {
        idQuestionario: self.model.id,
        excluido: false,
        dataVigenciaString: self.datePicker.dataVigencia//dataVigenciaParsed.toISOString().split("T")[0]
      }
    },
    fecharModalArquivos: function() {
      const self = this;
      self.$refs.formEnvioArquivo.reset();

      self.arquivoDeclaracaoSeguro = null;
      self.arquivoOutros = null;
      self.descricaoEnvio = '';

      self.datePicker = {
        opened: false,
        dataVigencia: null,
        dataVigenciaFormatted: null
      },

      self.modalUpload = false;
    },
    removeArquivo: function(tipoArquivo) {
      const self = this;
      eval('this.' + tipoArquivo + ' = null;');
      self.datePicker = {
        opened: false,
        dataVigencia: null,
        dataVigenciaFormatted: null
      };
    },
    resetArquivoModel: function() {
      const self = this;
      self.arquivoModel = {
        descricao: '',
        nomeArquivo: null,
        tipoArquivo: {}, 
        idQuestionario: null,
        tokenUsuario: null,
        mimeType: null,
        downloadLink: null,
        visualizacaoAnalista: false,
        visualizacaoCliente: false
      };
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/solicitacao-consulta/ArquivosOutros.vue